import { extendTheme } from "@chakra-ui/react";

const navy = "#023047";
const teal = "#219ebc";
const ice = "#f4fafc";
const border = "#d5e4ea";
const muted = "#5c6b73";

const underlineTab = {
  border: "none",
  borderBottom: "2px solid transparent",
  borderRadius: "0",
  mb: "-1px",
  fontWeight: 500,
  fontSize: "0.8125rem",
  color: muted,
  bg: "transparent",
  _selected: {
    color: navy,
    borderColor: navy,
    bg: "transparent",
  },
  _hover: {
    color: navy,
    bg: "#e7f2f6",
  },
};

const theme = extendTheme({
  fonts: {
    heading: '"Outfit", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    body: '"Outfit", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
  colors: {
    blue: {
      50: "#e8f4f8",
      100: "#d0e8f0",
      200: "#a8d4e4",
      300: "#6bb8d0",
      400: teal,
      500: navy,
      600: "#012536",
      700: "#011c29",
      800: "#01141d",
      900: "#000c12",
    },
  },
  radii: {
    md: "0.75rem",
    lg: "0.875rem",
    xl: "1rem",
  },
  shadows: {
    outline: "none",
    sm: "0 1px 2px rgba(2, 48, 71, 0.04)",
    md: "0 1px 2px rgba(2, 48, 71, 0.06)",
  },
  styles: {
    global: {
      body: {
        bg: ice,
        color: navy,
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: 600,
      },
      variants: {
        solid: {
          borderRadius: "9999px",
        },
        outline: {
          borderRadius: "9999px",
        },
        ghost: {
          borderRadius: "9999px",
        },
      },
    },
    Input: {
      defaultProps: {
        focusBorderColor: teal,
      },
      variants: {
        outline: {
          field: {
            borderRadius: "0.75rem",
            borderColor: border,
            bg: "white",
          },
        },
      },
    },
    Textarea: {
      defaultProps: {
        focusBorderColor: teal,
      },
      variants: {
        outline: {
          borderRadius: "0.75rem",
          borderColor: border,
          bg: "white",
        },
      },
    },
    Select: {
      defaultProps: {
        focusBorderColor: teal,
      },
      variants: {
        outline: {
          field: {
            borderRadius: "0.75rem",
            borderColor: border,
            bg: "white",
          },
        },
      },
    },
    FormLabel: {
      baseStyle: {
        fontSize: "sm",
        fontWeight: 600,
        color: navy,
      },
    },
    Tabs: {
      defaultProps: {
        variant: "line",
        colorScheme: "gray",
      },
      variants: {
        line: {
          tablist: {
            borderBottom: `1px solid ${border}`,
          },
          tab: underlineTab,
        },
        enclosed: {
          tablist: {
            borderBottom: `1px solid ${border}`,
          },
          tab: underlineTab,
          tabpanel: {
            border: "none",
            p: 0,
            pt: 4,
          },
        },
      },
    },
    Table: {
      variants: {
        simple: {
          th: {
            fontSize: "xs",
            letterSpacing: "0.04em",
            textTransform: "uppercase",
            color: muted,
            borderColor: border,
          },
          td: {
            borderColor: border,
          },
        },
      },
    },
  },
});

export default theme;
